import React from 'react'

const DatabaseContext = React.createContext()

export default DatabaseContext
